import { createSelector } from 'reselect';
import * as semrush from '@anm/helpers/semrush';
import { ApplicationState } from '../../types';

const DEFAULT_LOGO_NAME = 'powered-by-wv-white.png';

export const selectBrands = ({ brands }: ApplicationState) => brands.brandsList.data;

export const selectCurrentBrandId = ({ brands }: ApplicationState) => brands.brandsList.currentBrandId;

export const selectBrandLogoList = createSelector(selectBrands, selectCurrentBrandId, (brandList, brandId) => {
  const list = brandList.find(b => b.id === brandId)?.logos;

  return semrush.isSemrushIframe() ? list?.filter(l => l.filename !== DEFAULT_LOGO_NAME) : list;
});

export const selectBrandName = createSelector(
  selectBrands,
  selectCurrentBrandId,
  (brandList, brandId) => brandList.find(b => b.id === brandId)?.name
);

export const selectIsPendingUploadLogo = ({ brands }: ApplicationState) => brands.uploadBrandLogo.isPending;

export const selectIsPendingDeleteLogo = ({ brands }: ApplicationState) => brands.deleteBrandLogo.isPending;

export const selectUploadedImageUrl = ({ brands }: ApplicationState) => brands.uploadBrandLogo.uploadedImageUrl;

export const selectIsCreateBrandFilePending = ({ brands }: ApplicationState) => brands.createBrandFile.isPending;

export const selectCreatedBrandFile = ({ brands }: ApplicationState) => brands.createBrandFile.createdFile;

export const selectCreateBrandFileState = ({ brands }: ApplicationState) => brands.createBrandFile;
